const TUIChat = {
  "按Enter发送，Ctrl+Enter换行": "Enter 키로 전송, Ctrl+Enter로 줄바꿈",
  "表情": "[이모티콘]",
  "查看更多": "더보기",
  "撤回": "메시지 철회",
  "撤回了一条消息": "님이 메시지를 철회했습니다",
  "打开": "열기",
  "单击下载": "클릭하여 다운로드",
  "下载": "다운로드",
  "点此投诉": "신고하기",
  "点击处理": "처리하기",
  "对方正在输入": "입력 중...",
  "发起群视频": "그룹 영상통화 시작",
  "发起群语音": "그룹 음성통화 시작",
  "发起通话": "통화 시작",
  "发送失败": "전송 실패",
  "复制": "복사",
  "复制成功": "클립보드에 복사됨",
  "该消息不存在": "해당 메시지가 존재하지 않습니다",
  "关闭阅读状态": "읽음 상태 끄기",
  "管理员开启全员禁言": "관리자가 전체 음소거를 설정했습니다",
  "欢迎使用TUICallKit": "TUICallKit에 오신 것을 환영합니다",
  "回复": "답장",
  "回复详情": "답글",
  "集成TUICallKit": "TUICallKit 연동",
  "检测到您暂未集成TUICallKit，无法体验音视频通话功能": "TUICallKit이 연동되어 있지 않아 음성/영상 통화를 이용할 수 없습니다.",
  "结束群聊": "그룹 통화 편집",
  "进行体验": "체험하기",
  "经度": "경도",
  "拒绝": "거절",
  "拒绝通话": "통화 거절",
  "开通腾讯实时音视频服务": "Tencent 실시간 음영상 서비스 연동",
  "聊天记录": "[채팅 기록]",
  "描述": "설명",
  "内容包含敏感词汇": "내용에 민감한 단어가 포함되어 있습니다",
  "您": "회원님",
  "您当前购买使用的套餐包暂未开通此功能": "구매하신 요금제에서는 이 기능을 지원하지 않습니다.",
  "您当前购买使用的套餐包暂未开通群消息已读回执功能": "구매하신 요금제에서는 그룹 메시지 읽음 확인 기능을 지원하지 않습니다.",
  "您当前购买使用的套餐包暂未开通在线用户列表功能": "구매하신 요금제에서는 온라인 사용자 목록 기능을 지원하지 않습니다.",
  "您已被管理员禁言": "관리자에 의해 음소거되었습니다",
  "您有": "있습니다",
  "请点击": "클릭",
  "请输入消息": "메시지를 입력해 주세요",
  "取消": "취소",
  "取消通话": "통화 취소",
  "全部已读": "모두 읽음",
  "确定": "확인",
  "确认重发该消息？": "해당 메시지를 재전송하시겠습니까?",
  "人关闭阅读状态": "읽음 상태 비활성화",
  "人未读": "읽지 않음",
  "人已读": "읽음",
  "删除": "삭제",
  "涉及敏感内容": "민감한 내용 포함",
  "申请加入": "가입 신청",
  "视频": "[비디오]",
  "视频通话": "영상통화",
  "条回复": "답글",
  "条入群申请": "그룹 가입 신청",
  "条新消息": "개 새 메시지",
  "通话时长": "통화 시간",
  "同意": "동의",
  "图片": "[이미지]",
  "图片消息失败,无效的图片格式": "이미지 전송 실패: 유효하지 않은 이미지 형식입니다.",
  "纬度": "위도",
  "未读": "읽지 않음",
  "位置": "[위치]",
  "文件": "[파일]",
  "文件不存在,请检查文件路径是否正确": "파일이 존재하지 않습니다. 파일 경로가 올바른지 확인해 주세요.",
  "文件大小超出了限制,如果上传文件,最大限制是100MB": "파일 크기가 제한을 초과했습니다. 파일 업로드 시 최대 허용 크기는 100MB입니다.",
  "文件消息失败,禁止发送违规封禁的文件": "파일 전송 실패: 금지된 파일은 전송할 수 없습니다.",
  "我": "나",
  "无法查看": "볼 수 없음",
  "无法定位到原消息": "원본 메시지로 이동할 수 없습니다",
  "无法收听": "재생할 수 없음",
  "正在加载": "로딩 중...",
  "加载结束": "로딩 완료",
  "无应答": "응답 없음",
  "系统消息": "시스템 메시지",
  "消息": "[메시지]",
  "消息或者资料中文本存在敏感内容,发送失败": "메시지 또는 프로필 텍스트에 민감한 내용이 포함되어 전송에 실패했습니다.",
  "消息详情": "메시지 상세 내용",
  "消息长度超出限制,消息长度不要超过12K": "메시지 길이가 제한을 초과했습니다. 메시지는 12K를 초과할 수 없습니다.",
  "消息中图片存在敏感内容,发送失败": "메시지의 이미지에 민감한 내용이 포함되어 전송에 실패했습니다.",
  "选择提醒的人": "멘션할 사람 선택",
  "已读": "읽음",
  "已过撤回时限": "철회 가능 시간이 지났습니다",
  "已接听": "응답됨",
  "已拒绝": "거부됨",
  "已同意": "승인됨",
  "引用": "답장",
  "引用失败": "답장 실패",
  "语音": "[음성]",
  "语音通话": "음성통화",
  "重新编辑": "다시 편집",
  "重新发送": "재전송",
  "转发": "전달",
  "翻译": "번역",
  "转文字": "텍스트로 변환",
  "隐藏": "숨김",
  "转发给": "에게 전달",
  "自定义": "[커스텀 메시지]",
  "自定义消息": "커스텀 메시지",
  "腾讯云 IM": "텐센트 클라우드 채팅",
  "空": "없음",
  "文本包含本地审核拦截词": "텍스트에 로컬 차단 단어가 포함되어 있습니다",
  "按住说话": "길게 눌러 말하기",
  "松开发送": "손을 떼어 전송",
  "松手取消": "손을 떼어 취소",
  "录音结束提醒": "녹음 종료까지 ",
  "语音播放失败": "음성 재생 실패",
  "请检查麦克风访问权限": "마이크 접근 권한을 확인해 주세요",
  "按压时间过短，请按压超过1秒": "녹음 시간이 너무 짧습니다. 1초 이상 길게 녹음해 주세요",
  "正在录音": "녹음 중",
  "继续上滑可取消": "계속 위로 밀면 취소됩니다",
  "松开手指 取消发送": "손을 떼어 전송 취소",
  "此机型暂不支持复制功能": "이 기종에서는 복사 기능을 지원하지 않습니다",
  "请开通翻译功能": "번역 기능을 활성화해 주세요",
  "请开通语音转文字功能": "음성→텍스트 기능을 활성화해 주세요",
  "翻译中": "번역 중",
  "转换中": "변환 중",
  "由IM提供翻译支持": "IM에서 번역을 지원합니다",
  "所有人": "모두",
  "已达到表情回应上限数量": "이모티콘 반응 최대 수에 도달했습니다",
  "等": "등",
  "人": "명",
  "返回": "돌아가기",
  "关闭": "닫기",
  "多选": "다중 선택",
  "合并转发": "묶음 전달",
  "逐条转发": "개별 전달",
  "未选择消息": "선택된 메시지가 없습니다",
  "[草稿]": "[초안]",
  "[消息]": "[메시지]",
  "[文本]": "[텍스트]",
  "[自定义消息]": "[커스텀 메시지]",
  "[图片]": "[이미지]",
  "[音频]": "[오디오]",
  "[语音]": "[음성]",
  "[视频]": "[비디오]",
  "[文件]": "[파일]",
  "[位置]": "[위치]",
  "[地理位置]": "[위치]",
  "[动画表情]": "[이모티콘]",
  "[群提示]": "[그룹 알림]",
  "[群提示消息]": "[그룹 알림]",
  "[聊天记录]": "[채팅 기록]",
  "[机器人自定义消息]": "[봇 커스텀 메시지]",
  "引用内容已撤回": "답장한 메시지가 철회되었습니다",
  "群聊的聊天记录": "그룹 채팅 기록",
  "和": " 및 ",
  "的聊天记录": "의 채팅 기록",
  "请升级IMSDK到v2.10.1或更高版本查看此消息": "해당 메시지를 보려면 IMSDK를 v2.10.1 이상으로 업데이트해 주세요",
  "该群聊已被解散": "해당 그룹이 해산되었습니다",
  "您已被管理员移出群聊": "관리자가 회원님을 그룹에서 제거했습니다",
  "您已退出该群聊": "그룹을 탈퇴했습니다",
  "您已被禁止聊天": "채팅 금지되었습니다",
  "账号被强制下线": "계정이 강제로 로그아웃되었습니다",
  "登录失败": "로그인 실패",
  "链接": "[링크]",
  "回到最新位置": "",
};

export default TUIChat;
